import type { ReactNode } from 'react';
import heroBg from '@/assets/download/bg.png';
import qa1Image from '@/assets/download/QA-1.png';
import qa2Image from '@/assets/download/QA-2.png';
import qrImage from '@/assets/download/qr-download.png';
import pcBg from '@/assets/download/pc-bg.jpg';
import macosIcon from '@/assets/download/macos.png';
import windowsIcon from '@/assets/download/windows.png';
import faqStyles from './components/FaqItem/index.module.scss';

export const HERO = {
  tag: '支持手机端+平板端',
  title: '爱学移动客户端',
  image: heroBg,
  qr: {
    image: qrImage,
    versions: 'iOS版本大于13.0\nAndroid版本大于7.0',
  },
};

export const PC = {
  tag: '专属AI学习智能体',
  title: '爱学 PC 客户端',
  note: '暂不支持XP系统的下载',
  background: pcBg,
};

export const DOWNLOAD_URL = {
  mac: 'https://cdn.yuaiweiwu.com/fe/aixue-clients/v1.0.3/aixue-1.0.3-mac-universal.dmg',
  windows32:
    'https://kannchwp.aiv5cdn.com/baichuan%2Fprod%2Fmarketing%2Fg3%2F0%2F2%2F32753637%2F32753702%2F37836557%2F37836575%2Faixue-1.0.3-windows-ia32.exe',
  windows64:
    'https://kannchwp.aiv5cdn.com/baichuan%2Fprod%2Fmarketing%2Fg3%2F0%2F2%2F32753637%2F32753702%2F37836557%2F37836576%2Faixue-1.0.3-windows-x64.exe',
};

export type PcDownloadId = keyof typeof DOWNLOAD_URL;

export interface PcDownloadOption {
  id: PcDownloadId;
  label: string;
  hint: string;
  url: string;
  icon: string;
}

export const PC_DOWNLOADS: PcDownloadOption[] = [
  {
    id: 'mac',
    label: 'Mac 版下载',
    hint: '版本大于等于12',
    url: DOWNLOAD_URL.mac,
    icon: macosIcon,
  },
  {
    id: 'windows64',
    label: 'Windows 64位下载',
    hint: '版本大于等于10',
    url: DOWNLOAD_URL.windows64,
    icon: windowsIcon,
  },
  {
    id: 'windows32',
    label: 'Windows 32位下载',
    hint: '版本大于等于10',
    url: DOWNLOAD_URL.windows32,
    icon: windowsIcon,
  },
];

export interface FaqItemData {
  question: string;
  answer?: ReactNode;
  image?: string;
}

export const FAQ_TITLE = '常见问题';

export const FAQS: FaqItemData[] = [
  {
    question: '1.Mac电脑（苹果电脑）如何查看操作系统版本不低于macOS 12？',
    answer: (
      <>
        <p>
          <strong>安装的是哪个 macOS 版本？</strong>
          <br />
          从屏幕左上角的苹果菜单 
          中，选取“关于本机”。打开的窗口看起来可能与这里显示的示例不同，但窗口中始终包含 macOS
          名称和版本号。如果你还需要知道内部版号，请点按版本号进行查看。
        </p>
        <img className={faqStyles.qaImgSm} src={qa1Image} alt="" loading="lazy" />
      </>
    ),
  },
  {
    question: '2.Windows电脑如何查看操作系统是32位还是64位？',
    answer: (
      <>
        <p>1. 按 Win+I 打开设置；</p>
        <p>2. 依次进入 系统 → 系统信息；</p>
        <p>
          3. 在 “设备规格” 区域，找到系统类型，显示 “64 位操作系统，基于 x64 的处理器”（64 位）或
          “32 位操作系统，基于 x86 的处理器”（32 位）。
        </p>
        <img className={faqStyles.qaImgMd} src={qa2Image} alt="" loading="lazy" />
      </>
    ),
  },
  {
    question: '3.移动端APP的支持情况？',
    answer: (
      <>
        <p>苹果系统：AppStore（iPad/iphone）</p>
        <p>
          移动端安卓APP支持范围：腾讯应用宝、华为、小米、华为、荣耀、OPPO、VIVO、步步高学习机、好未来学习机、希沃学习机、科大讯飞学习机
        </p>
        <p className={faqStyles.warn}>不支持的设备：作业帮学习机、猿辅导学习机、优学派学习机</p>
      </>
    ),
  },
  {
    question: '4.网络差如何进行优化？',
    answer: (
      <>
        <p>
          1. 网络连接优化：优先连 5G Wi-Fi（避开 2.4G 频段拥堵），路由器放房间中心、远离墙体 /
          家电，手机 / 电脑靠近路由器；Wi-Fi 卡顿可切换手机流量测试，排除路由器故障。
        </p>
        <p>
          2. 设备后台清理：关闭设备后台下载、云同步、自动更新（尤其是系统 /
          大文件更新），暂停其他设备的视频、游戏等高带宽占用行为。
        </p>
        <p>
          3. 路由器基础调试：重启路由器（拔掉电源 30 秒再插上），定期更新路由器固件；若支持 QoS
          功能，将视频 APP 设为带宽优先级。
        </p>
        <p>
          4. 网络环境排查：避开高峰时段（晚 7-11
          点）观看其他视频，避免宽带占用；手机可切换飞行模式重连网络（使用流量或者WiFi），电脑重置网络设置（Win：cmd
          输入 netsh winsock reset）。
        </p>
      </>
    ),
  },
];
